"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDITOR_TABS = void 0;
exports.editorOptions = editorOptions;
const items_1 = require("./items");
const nicknameMessages_1 = require("./nicknameMessages");
const options_1 = require("./options");
const random_1 = require("./random");
const hairShows = (config) => config.top !== 'none' && !(0, random_1.coversHair)(config.headwear);
/** The avatar editor's layout, shared by the web and native editors. */
exports.EDITOR_TABS = [
    { id: 'skin', label: 'Skin', sections: [{ trait: 'skin', label: 'Skin tone', kind: 'color' }] },
    {
        id: 'hair',
        label: 'Hair',
        sections: [
            { trait: 'hairColor', label: 'Hair color', kind: 'color', enabled: config => hairShows(config) || config.facialHair !== 'none' },
            { trait: 'top', label: 'Style', kind: 'preview', previewFaceless: true, previewWithout: ['headwear', 'glasses', 'facialHair', 'prop'] },
        ],
    },
    {
        id: 'face',
        label: 'Face',
        sections: [],
        subTabs: [
            { id: 'eyes', label: 'Eyes', sections: [{ trait: 'eyes', label: 'Eyes', kind: 'preview', previewWithout: ['glasses', 'prop'] }] },
            { id: 'eyebrows', label: 'Eyebrows', sections: [{ trait: 'eyebrows', label: 'Eyebrows', kind: 'preview', previewWithout: ['glasses', 'prop'] }] },
            { id: 'mouth', label: 'Mouth', sections: [{ trait: 'mouth', label: 'Mouth', kind: 'preview', previewWithout: ['glasses', 'prop'] }] },
            { id: 'facialHair', label: 'Facial hair', sections: [{ trait: 'facialHair', label: 'Facial hair', kind: 'preview', previewWithout: ['glasses', 'prop'] }] },
        ],
    },
    {
        id: 'outfit',
        label: 'Outfit',
        sections: [
            { trait: 'clothesColor', label: 'Clothing color', kind: 'color' },
            { trait: 'accentColor', label: 'Tie color', kind: 'color', enabled: config => config.clothing === 'suit' },
            { trait: 'clothing', label: 'Clothing', kind: 'preview', previewWithout: ['prop'] },
        ],
    },
    {
        id: 'prop',
        label: 'Props',
        sections: [],
        subTabs: [
            {
                id: 'accessory',
                label: 'Accessory',
                sections: [
                    { trait: 'propColor', label: 'Color', kind: 'color', enabled: config => options_1.COLORED_PROPS.includes(config.prop) },
                    { trait: 'prop', label: 'Accessory', kind: 'preview' },
                ],
            },
            {
                id: 'headwear',
                label: 'Headwear',
                sections: [
                    { trait: 'hatColor', label: 'Headwear color', kind: 'color', enabled: config => config.headwear !== 'none' && (0, items_1.itemIdOf)(config.headwear) === null },
                    { trait: 'headwear', label: 'Headwear', kind: 'preview', previewFaceless: true, previewWithout: ['glasses', 'facialHair', 'prop'] },
                ],
            },
            {
                id: 'glasses',
                label: 'Glasses',
                sections: [
                    { trait: 'glassesColor', label: 'Frame color', kind: 'color', enabled: config => config.glasses !== 'none' },
                    { trait: 'glasses', label: 'Glasses', kind: 'preview', previewWithout: ['prop'] },
                ],
            },
        ],
    },
    { id: 'background', label: 'Background', sections: [{ trait: 'background', label: 'Background', kind: 'gradient' }] },
];
/**
 * Everything the editor offers for a trait, in order: the built-in options,
 * then the back-office items for that slot. A limited-time item whose window
 * has passed is offered only to those who own it; a challenge prize is shown
 * locked to everyone else, so they know it can be won.
 */
function editorOptions(trait, { items, ownedItemIds, unlockedMedals, now = new Date() }) {
    const builtIn = options_1.AVATAR_OPTIONS[trait].map((value) => {
        const medalTier = trait === 'prop' ? options_1.MEDAL_PROPS[value] : undefined;
        const locked = medalTier !== undefined && !unlockedMedals.includes(medalTier);
        return { value, lockedMessage: locked ? (0, nicknameMessages_1.medalLockedMessage)(medalTier) : null, note: null };
    });
    const slot = (0, items_1.itemSlotOfTrait)(trait);
    if (!slot)
        return builtIn;
    const fromItems = items
        .filter(item => item.slot === slot && (item.unlock === 'reward' || (0, items_1.canWearItem)(item, ownedItemIds, now)))
        .map((item) => {
        const wearable = (0, items_1.canWearItem)(item, ownedItemIds, now);
        const claimable = wearable && item.unlock === 'timed' && !ownedItemIds.includes(item.id) && (0, items_1.isItemWindowOpen)(item, now);
        return {
            value: (0, items_1.itemValue)(item.id),
            lockedMessage: wearable ? null : (0, items_1.itemLockedMessage)(item, now),
            note: claimable ? (0, items_1.itemClaimMessage)(item) : null,
        };
    });
    return [...builtIn, ...fromItems];
}
